import { Workbook } from "exceljs"
import { convertToText } from "number-to-text"
import Swal from "sweetalert2"

export const changeState = (setState, data) => setState((prev) => ({ ...prev, ...data }))
export const emptyObject = (object) => Object.keys(object ?? {}).length === 0
export const isEmpty = (variable) => [null, "", undefined].includes(variable)
export const hasProps = (obj, prop_name) => Object.hasOwn(obj ?? {}, prop_name)
export const converParamUrlToObject = (param = "") => Object.fromEntries(new URLSearchParams(param))
export const formatCurrency = (num, option = {}) => {
	if (typeof num === "string") return num
	const options = { style: "decimal", minimumFractionDigits: 2, ...option }
	return Intl.NumberFormat("en-US", options).format(num)
}
export const numberToWords = (number, lng = "id", currency = "") => {
	const wholePart = Math.floor(parseFloat(number))
	const decimalPart = (parseFloat(number) - wholePart).toFixed(4)
	const decimalWord = lng === "id" ? " koma " : " point "
	const language = lng === "id" ? "id" : "en-us"
	if (Math.round(decimalPart) === 0) return convertToText(wholePart, { language }) + " " + currency
	return convertToText(wholePart, { language }) + decimalWord + convertToText(decimalPart, { language }) + " " + currency
}
export const readFile = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.readAsArrayBuffer(file)
		reader.onload = () => {
			resolve(reader.result)
		}
	})
}
export const readExcelFile = async (file, worksheet = 1) => {
	const workbook = new Workbook()
	const buffer = await readFile(file)
	const excel = await workbook.xlsx.load(buffer)
	const _worksheet = excel.getWorksheet(worksheet)
	return _worksheet
}

export const getLinkCode = (pathname = '/') => {
	// const partOfPath = pathname.split('/').filter(Boolean)
	// const actPath = accessRouteMenuActionKey[partOfPath[partOfPath.length - 1]];
	// const pathJoinNum = partOfPath.length === 2 ? (!isEmpty(actPath) ? 1 : 2) : 2
	// const keyLink = partOfPath.slice(0, pathJoinNum).join('_');
	// // console.log(pathname, partOfPath, actPath, pathJoinNum, keyLink)
	// const menuCode = accessRouteMenuKey[keyLink] ?? ""
	return { menuCode: "", partOfPath: "", actPath: "" }
}

export const getAccMenu = () => {
	// const pathname = useLocation().pathname
	// const { menuCode } = getLinkCode(pathname)
	// const accMenu = useAuth(useShallow((state) => state.accMenu));
	// return accMenu[menuCode]
}


// tanstack
export const createOrderValue = (sorting) => {
	return sorting.length === 1 ? { [sorting.id]: sorting.values ? "DESC" : "ASC" } : {}
}

// alert
export const deleteAlert = async ({ title, text, icon = "warning" }) => {
	return Swal.fire({
		icon,
		title,
		text,
		allowOutsideClick: false,
		cancelButtonText: "Batal",
		showCancelButton: true,
		confirmButtonText: "Ok",
		confirmButtonColor: "var(--primary_color)",
		cancelButtonColor: "#d33",
	}).then((res) => res)
}

export const deleteAlertWithInput = async ({ title, text, placeholder = "Alasan", icon = "warning" }) => {
	return Swal.fire({
		title,
		icon,
		html: `
            <labe>${text}</labe>
            <textarea id='reason' class='scroll_container swal2-textarea' placeholder=${placeholder}></textarea>
        `,
		preConfirm: () => Swal.getPopup().querySelector("#reason")?.value ?? "",
		allowOutsideClick: false,
		cancelButtonText: "Batal",
		showCancelButton: true,
		confirmButtonText: "Ok",
		confirmButtonColor: "var(--primary_color)",
		cancelButtonColor: "#d33",
	}).then((res) => res)
}
